import { gradeFromGradYear } from "@/utils/gradeFromGradYear";
import type { PreferenceRow } from "../../components/assign/AssignDataTable";

export const buildAssignRows = (data: {
  preferences: any[];
  explorations: any[];
  students: any[];
}): PreferenceRow[] => {
  const explorationById = new Map<string, any>(
    data.explorations.map((e) => [String(e._id), e]),
  );

  const studentById = new Map<string, any>(
    data.students.map((s) => [String(s._id), s]),
  );

  return data.preferences.map((p) => {
    const studentId = String(p.student);
    const student = studentById.get(studentId);

    const choice1Id = String(p.choices?.[0] ?? "");
    const choice2Id = String(p.choices?.[1] ?? "");
    const choice3Id = String(p.choices?.[2] ?? "");

    const choice1 = choice1Id ? explorationById.get(choice1Id) : undefined;
    const choice2 = choice2Id ? explorationById.get(choice2Id) : undefined;
    const choice3 = choice3Id ? explorationById.get(choice3Id) : undefined;

    return {
      preferenceId: String(p._id),
      studentId,
      studentName: student?.name ?? "-",
      studentGrade: Number(gradeFromGradYear(student?.gradYear) ?? 0),
      choice1: {
        id: choice1Id,
        resolved: !!choice1,
        name: choice1?.name ?? "-",
        min: choice1?.minEnrollment ?? 0,
        max: choice1?.maxEnrollment ?? 0,
        enrolled: choice1?.enrolled ?? 0,
      },
      choice2: {
        id: choice2Id,
        resolved: !!choice2,
        name: choice2?.name ?? "-",
        min: choice2?.minEnrollment ?? 0,
        max: choice2?.maxEnrollment ?? 0,
        enrolled: choice2?.enrolled ?? 0,
      },
      choice3: {
        id: choice3Id,
        resolved: !!choice3,
        name: choice3?.name ?? "-",
        min: choice3?.minEnrollment ?? 0,
        max: choice3?.maxEnrollment ?? 0,
        enrolled: choice3?.enrolled ?? 0,
      },
    };
  });
};
